import React, { useRef } from 'react';
import { P5CanvasInstance, ReactP5Wrapper } from '@p5-wrapper/react';

export const Landscape: React.FC = (props) => {
    const p5ref = useRef<P5CanvasInstance>();
    function sketch(p5: P5CanvasInstance) {
        p5ref.current = p5;
        const width = 640;
        const height = 240;
        let land: Terrain;
        let theta = 0.0;

        p5.setup = () => {
            p5.createCanvas(width, height, "webgl");
            land = new Terrain(p5, 20, 800, 400);            
        }

        p5.draw = () => {
            land.calculate();
            p5.background(255);
            p5.push();
            p5.translate(0, 20, -200);
            p5.rotateX(p5.PI / 3);
            p5.rotateZ(theta);
            land.render();
            p5.pop();

            theta += 0.0025;
        };
    }

    return <ReactP5Wrapper sketch={sketch} />;
};

export default Landscape;

function make2DArray(cols: number, rows: number): number[][] {
    let arr = new Array(cols);
    for (let i = 0; i < arr.length; i++) {
        arr[i] = new Array(rows);
    }
    return arr;
}

class Terrain {
    p5: P5CanvasInstance;
    scl: number;
    w: number;
    h: number;
    cols: number;
    rows: number;
    z: any[];
    zoff: number;

    constructor(p5: P5CanvasInstance, scl: number, w: number, h: number) {
        this.p5 = p5;
        this.scl = scl;  // size of each cell
        this.w = w;
        this.h = h;
        this.cols = Math.floor(w / scl);
        this.rows = Math.floor(h / scl);

        // using an array to store all the height values 
        this.z = make2DArray(this.cols, this.rows);

        // perlin noise argument
        this.zoff = 0;
    }


    // Calculate height values (based off a neural network)
    calculate() {
        let xoff = 0;
        for (let i = 0; i < this.cols; i++) {
            let yoff = 0;
            for (let j = 0; j < this.rows; j++) {
                this.z[i][j] = this.p5.map(this.p5.noise(xoff, yoff, this.zoff), 0, 1, -120, 120);
                yoff += 0.08;
            }
            xoff += 0.1;
        }
        this.zoff += 0.007;
    }

    render() {
        // Every cell is an individual quad
        // WTF is a quad?
        for (let x = 0; x < this.z.length - 1; x++) {
            this.p5.beginShape(this.p5.QUAD_STRIP);

            for (let y = 0; y < this.z[x].length; y++) {
                this.p5.stroke(0);

                let currentElevation = this.z[x][y];
                let currentShade = this.p5.map(currentElevation, -120, 120, 0, 255);

                this.p5.fill(currentShade, 255);

                let xCoordinate = x * this.scl - this.w / 2;
                let yCoordinate = y * this.scl - this.h / 2;

                this.p5.vertex(xCoordinate, yCoordinate, this.z[x][y]);
                this.p5.vertex(xCoordinate + this.scl, yCoordinate, this.z[x + 1][y]);
            }

            this.p5.endShape();
        }
    }
}